import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";
import { IMAGES } from "../../lib/i18n";

export default function Sustainability() {
  const { t } = useLang();
  const c = t.sustainability;
  return (
    <section data-testid="sustainability-section" className="py-24 sm:py-32 border-t border-border">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section text-olive">
            {c.title}
          </Reveal>
        </div>

        <div className="grid grid-cols-12 gap-x-6 gap-y-10 mb-16">
          <Reveal className="col-span-12 lg:col-span-6">
            <p className="text-lg text-olive-soft leading-relaxed">{c.bodyA}</p>
          </Reveal>
          <Reveal className="col-span-12 lg:col-span-6">
            <p className="text-lg text-olive-soft leading-relaxed">{c.bodyB}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-12 gap-6 lg:gap-10">
          <Reveal className="col-span-12 lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden">
              <img src={IMAGES.investment} alt="Tierra fértil sostenible" className="w-full h-full object-cover" />
            </div>
          </Reveal>

          <div className="col-span-12 lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-border">
            {c.pillars.map((p, i) => (
              <Reveal
                key={i}
                delay={i * 70}
                data-testid={`sustainability-pillar-${i}`}
                className="bg-ivory p-8"
              >
                <div className="font-mono text-[10px] tracking-[0.35em] uppercase text-terracotta mb-3">{p.tag}</div>
                <div className="font-display text-2xl text-olive mb-3 leading-tight">{p.title}</div>
                <p className="text-olive-soft leading-relaxed">{p.body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
